import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import nl from "../locales/nl.json";
import en from "../locales/en.json";
import de from "../locales/de.json";
import fr from "../locales/fr.json";
import es from "../locales/es.json";
import it from "../locales/it.json";
import pl from "../locales/pl.json";
import pt from "../locales/pt.json";
import sv from "../locales/sv.json";
import da from "../locales/da.json";

export const SUPPORTED_LANGUAGES = ["nl", "en", "de", "fr", "es", "it", "pl", "pt", "sv", "da"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      nl: { translation: nl },
      en: { translation: en },
      de: { translation: de },
      fr: { translation: fr },
      es: { translation: es },
      it: { translation: it },
      pl: { translation: pl },
      pt: { translation: pt },
      sv: { translation: sv },
      da: { translation: da },
    },
    fallbackLng: "nl",
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "nibro_lang",
      caches: ["localStorage"],
    },
    returnEmptyString: false,
  });

export default i18n;
